import { hashObject, } from '@verdant-web/common';
import { GetQuery } from './GetQuery.js';
import { FindOneQuery } from './FindOneQuery.js';
import { FindPageQuery } from './FindPageQuery.js';
import { FindInfiniteQuery } from './FindInfiniteQuery.js';
import { FindAllQuery } from './FindAllQuery.js';
import { UPDATE } from './BaseQuery.js';
export class CollectionQueries {
    constructor({ collection, cache, entities, context, documentManager, }) {
        this.serializeIndex = (index) => {
            if (!index)
                return '';
            return hashObject(index);
        };
        this.get = (id) => {
            const key = `get:${this.collection}:${id}`;
            return this.cache.getOrSet(key, () => new GetQuery({
                id,
                collection: this.collection,
                hydrate: this.hydrate,
                context: this.context,
                key,
            }));
        };
        this.findOne = ({ index, key: providedKey, } = {}) => {
            const key = providedKey || `findOne:${this.collection}:${this.serializeIndex(index)}`;
            return this.cache.getOrSet(key, () => new FindOneQuery({
                index,
                collection: this.collection,
                hydrate: this.hydrate,
                context: this.context,
                key,
            }), (existing) => {
                existing[UPDATE](index);
            });
        };
        this.findAll = ({ index, key: providedKey, } = {}) => {
            const key = providedKey || `findAll:${this.collection}:${this.serializeIndex(index)}`;
            return this.cache.getOrSet(key, () => new FindAllQuery({
                index,
                collection: this.collection,
                hydrate: this.hydrate,
                context: this.context,
                key,
            }), (existing) => {
                existing[UPDATE](index);
            });
        };
        this.findPage = ({ index, pageSize, page, key: providedKey, }) => {
            const key = providedKey ||
                `findPage:${this.collection}:${this.serializeIndex(index)}:${pageSize}`;
            return this.cache.getOrSet(key, () => new FindPageQuery({
                index,
                collection: this.collection,
                hydrate: this.hydrate,
                context: this.context,
                key,
                pageSize,
                page,
            }), (existing) => {
                existing[UPDATE](index);
            });
        };
        this.findAllInfinite = ({ index, pageSize, key: providedKey, }) => {
            const key = providedKey ||
                `findAllInfinite:${this.collection}:${this.serializeIndex(index)}:${pageSize}`;
            return this.cache.getOrSet(key, () => new FindInfiniteQuery({
                index,
                collection: this.collection,
                hydrate: this.hydrate,
                context: this.context,
                key,
                pageSize,
            }), (existing) => {
                existing[UPDATE](index);
            });
        };
        this.cache = cache;
        this.collection = collection;
        this.hydrate = entities.hydrate;
        this.context = context;
        this.documentManager = documentManager;
        this.put = this.documentManager.create.bind(this.documentManager, this.collection);
        this.delete = this.documentManager.delete.bind(this.documentManager, this.collection);
        this.deleteAll = this.documentManager.deleteAllFromCollection.bind(this.documentManager, this.collection);
        this.clone = this.documentManager.clone.bind(this.documentManager, this.collection);
    }
}
//# sourceMappingURL=CollectionQueries.js.map